import {appWorkspaceKey} from '@dms/config';

import {isRunningInCypress} from 'shared/web';

import {doc360Routes, microsoftOAuthRedirect, workspaceInitializeRoute} from '../constants/routes';

type GetWorkspaceFromUri = {
  workspace?: string;
  domain: string;
  shouldRedirectToAppWorkspace: boolean;
  isReviewApp: boolean;
};

const DEFAULT_REVIEW_TENANT = 'metada';
const REVIEW_APP = 'review';

const ALLOWED_ROUTES_WITHOUT_WORKSPACE = [
  doc360Routes.workspaceSelection,
  microsoftOAuthRedirect,
  workspaceInitializeRoute,
];

const POSSIBLE_WORKSPACES = [
  'localhost',
  'localhost:4200',
  'dev',
  'stage',
  'review',
  'localhost:4201',
];

/**
 * Get OMNETIC workspace from current hostname
 * The list of possible urls looks like this
 * 1. localhost:3000
 * 2. carvago.localhost:3000
 * 3. carvago.dev.teasdev.com
 * 4. develop.review.teasdev.com
 * 5. app.stage.teasdev.com
 */
export const getWorkspaceFromUri = (url?: string): GetWorkspaceFromUri => {
  const [wsp, ...rest] = (url || window.location.host).split('.');
  const isReviewApp = window.location.href.includes(REVIEW_APP);
  const isNoWorkspaceFound = POSSIBLE_WORKSPACES.includes(wsp);

  if (isRunningInCypress()) {
    return {
      workspace: 'e2e',
      domain: window.location.host,
      shouldRedirectToAppWorkspace: false,
      isReviewApp,
    };
  }

  if (isNoWorkspaceFound) {
    return {
      domain: window.location.host,
      shouldRedirectToAppWorkspace: true,
      isReviewApp,
    };
  }

  const domain = rest.join('.');

  const isAllowedRoute = ALLOWED_ROUTES_WITHOUT_WORKSPACE.includes(window.location.pathname);

  if ((wsp === appWorkspaceKey && !isAllowedRoute) || (wsp !== appWorkspaceKey && isAllowedRoute)) {
    return {
      workspace: wsp,
      domain,
      isReviewApp,
      shouldRedirectToAppWorkspace: true,
    };
  }

  return {
    workspace: isReviewApp ? DEFAULT_REVIEW_TENANT : wsp,
    domain,
    isReviewApp,
    shouldRedirectToAppWorkspace: false,
  };
};
